import { UserLocationResolver } from './users-location.resolver';
import { UserLocationListResolver } from './users-location.list.resolver';

export const USER_LOCATION_RESOLVERS = [UserLocationListResolver, UserLocationResolver];
